<div class="multiselect" [ngClass]="{'multiselect-light': theme === 'light'}" #multiselect>
  <input type="text" class="hidden-input" (focus)="openDropdown()" (keydown.arrowdown)="onSelectOption('down')"
    (keydown.arrowup)="onSelectOption('up')" (keydown.enter)="onEnter()" #multiDropdownInput>
  <div [id]="id" [hidden]="hasCustomHeader" class="multiselect-view"
    [ngClass]="{'hover-bg': hasHoverEffect, 'active-bg': hasBgOnActive}" (click)="openDropdown()">
    <p class="multiselect-view-text text-truncate" [ngClass]="{
        'placeholder': !values.length,
        'font-10': fontSize === 10,
        'font-12': fontSize === 12,
        'font-14': fontSize === 14
       }">
      {{(values.length)? renderSelectedValue() : placeholder}}
    </p>
  </div>

  <div [hidden]="!hasCustomHeader" (click)="openDropdown()">
    <ng-container *ngTemplateOutlet="multiSelectHeader">
    </ng-container>
  </div>

  <div class="multiselect-list-wrapper" [ngStyle]="{
    'display': isDropdownExpanded? 'block': 'none',
    minWidth: itemWidth? itemWidth: '100%'
  }" [ngClass]="{'top': vPosition === 'top', 'bottom': vPosition === 'bottom'}">
    <div class="multiselect-list-header flex-between-center">
      <span [ngClass]="{
        'font-10': fontSize === 10,
        'font-12': fontSize === 12,
        'font-14': fontSize === 14
      }">{{headerTitle}}</span>
      <i class="fal fa-times pointer font-gray" (click)="close()"></i>
    </div>
    <ul [id]="listId" [ngStyle]="{'max-height': scrollHeight}" class="multiselect-list" #dropdownList>
      <li *ngFor="let option of options; let optionIndex = index" class="multiselect-list-item flex-start-center"
        [id]="'item-' + id + optionIndex" [ngClass]="{'hover': selectedOptionIndex === optionIndex, 'cursor-not-allowed-imporant disabled-estimate-field': option?.disabled }"
        (click)="option?.disabled ? '' : onSelectItem(option, optionIndex)">
        <span class="item-initials flex-center-center mr-2 pointer" [ngClass]="{'active': option.isChecked}">
          <span *ngIf="option?.initials === undefined" class="initial-text" [ngClass]="{
            'font-10': fontSize === 10,
            'font-12': fontSize === 12,
            'font-14': fontSize === 14
          }">{{helperService.fetchInitials(option[field])}}</span>
          <span *ngIf="option?.initials" class="initial-text" [ngClass]="{
            'font-10': fontSize === 10,
            'font-12': fontSize === 12,
            'font-14': fontSize === 14
          }">{{option?.initials}}</span>
          <i class="fal fa-check check-icon"></i>
        </span>
        <span [ngClass]="{
          'font-10': fontSize === 10,
          'font-12': fontSize === 12,
          'font-14': fontSize === 14
        }">{{renderLabel(option)}}</span>
      </li>
    </ul>
    <div class="multiselect-list-footer flex-between-center" [hidden]="selectionLimit != undefined && selectionLimit < options.length">
      <span [id]="'select-all-' + id" [hidden]="(options.length === selectedItemCount) && selectedItemCount"
        (click)="onSelectAll()" class="font-primary pointer pr-2" [ngClass]="{
        'font-10': fontSize === 10,
        'font-12': fontSize === 12,
        'font-14': fontSize === 14
      }">
        Select All
      </span>
      <span [hidden]="(options.length !== selectedItemCount) || selectedItemCount === 0" (click)="onUnSelectAll()"
        class="font-primary pointer pr-2" [ngClass]="{
        'font-10': fontSize === 10,
        'font-12': fontSize === 12,
        'font-14': fontSize === 14
      }">
        Unselect All
      </span>
    </div>
  </div>
</div>
